// export const backendUrl = 'http://localhost:3030'
// 'https://jifi-api.july.com'

export const backendUrl = 'https://jifi-api-staging.july.com'